import Vue from 'vue';
import { Dialog, Toast, Button } from '@xl/m-ui';

Vue.use(Toast).use(Dialog).use(Button);
